export default __webpack_public_path__ + "static/media/asset-1.900b7c70.svg";